/**
 * Shared recent-directory-search chips (sidebar + /search discover).
 */

import { useTranslation } from 'react-i18next';
import { Icon } from '../icons/Icon';

export interface DirectoryRecentSearchesProps {
  recents: string[];
  onSelect: (query: string) => void;
  onRemove?: (query: string) => void;
  onClear?: () => void;
  /** i18n key for the section label */
  labelKey?: string;
  className?: string;
  /** When false, hide per-chip remove and Clear (platform suggestions). */
  editable?: boolean;
}

export function DirectoryRecentSearches({
  recents,
  onSelect,
  onRemove,
  onClear,
  labelKey = 'search.yourRecentSearches',
  className = '',
  editable = true,
}: DirectoryRecentSearchesProps) {
  const { t } = useTranslation();

  if (recents.length === 0) return null;

  return (
    <div className={`search-recent ${className}`.trim()}>
      <div className="search-recent-header">
        <p className="search-recent-label">{t(labelKey)}</p>
        {editable && onClear ? (
          <button type="button" className="search-recent-clear" onClick={onClear}>
            {t('search.clearRecentSearches')}
          </button>
        ) : null}
      </div>
      <ul className="search-recent-list">
        {recents.map((recent) => (
          <li key={recent} className="search-recent-chip">
            <button
              type="button"
              className="search-recent-chip-query"
              onClick={() => onSelect(recent)}
            >
              {recent}
            </button>
            {editable && onRemove ? (
              <button
                type="button"
                className="search-recent-chip-remove"
                aria-label={t('search.removeRecentSearch', { query: recent })}
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(recent);
                }}
              >
                <Icon name="x" size="xs" />
              </button>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
